import Api from '@/http/api'
import { Toast, Dialog } from 'mand-mobile'
import LocalStore from '@/utils/localStore'
import Cookie from '@/utils/cookie'
import router from '@/router/index'
import { EXECUTE_USER_LOGIN, EXECUTE_USER_LOGOUT, LOGOUT_CART_CLEAR, SET_AUTH_TB_ACCOUNT_INFO } from '@/store/mutation-types'
import vuexStore from '@/store'
import Consts from '@/common/consts'
import _AP from '@/utils/ap'
import { isWeiXin } from '@/utils/help'

export default {
  /**
   * 账号密码登录
   * @param mobile 手机号
   * @param md5Pwd md5加密后的密码
   * @param isFromRegister 是否来自注册页面
   */
  accountLogin: async function(mobile, md5Pwd, isFromRegister) {
    try {
      if (isFromRegister) {
        Toast.loading('登陆中')
      }
      let res = await Api.user.userLogin({ userName: mobile, passWord: md5Pwd })
      Cookie.set(Consts.COOKIE_USER_MD5_PWD, md5Pwd) // 保存加密后的密码, 用于自动登录
      if (isFromRegister) {
        Toast.hide()
      }
      this.successLogin('account', res.data, false, true)
    } catch (err) {
      console.log('账号密码登录 Error', err)
      throw new Error(err.message)
    }
  },

  /**
   * 自动登录
   * @param showMsg 是否需要弹出提示登录成功
   */
  autoLogin: async function(showMsg) {
    if (!LocalStore.get(Consts.STORE_DOING_LOGIN, false)) {
      LocalStore.set(Consts.STORE_DOING_LOGIN, true)
      try {
        // 清除token及用户信息
        Cookie.del(Consts.COOKIE_USER_TOKEN)
        Cookie.del(Consts.COOKIE_USER_INFO)
        Cookie.del(Consts.COOKIE_AUTH_TB_ACCOUNT_NAME)
        Cookie.del(Consts.COOKIE_AUTH_TB_ACCOUNT_RELATION_ID)
        vuexStore.commit(EXECUTE_USER_LOGOUT)
        let loginType = Cookie.get(Consts.COOKIE_USER_LOGIN_TYPE)
        if (loginType === 'account') {
          // 账号密码登录
          const mobile = Cookie.get(Consts.COOKIE_USER_MOBILE)
          const md5Pwd = Cookie.get(Consts.COOKIE_USER_MD5_PWD)
          if (mobile && md5Pwd) {
            const res = await Api.user.userLogin({ userName: mobile, passWord: md5Pwd })
            LocalStore.remove(Consts.STORE_DOING_LOGIN)
            this.successLogin('account', res.data, true, showMsg)
          } else {
            this.goLoginPage()
          }
        } else {
          this.goLoginPage()
        }
      } catch (err) {
        console.log('自动登录异常', err)
        this.goLoginPage()
      }
    }
  },

  /**
   * 跳转至登录页面
   */
  goLoginPage() {
    LocalStore.remove(Consts.STORE_DOING_LOGIN)
    router.replace({ name: 'login', query: { target: encodeURIComponent(router.currentRoute.fullPath) } })
  },

  /**
   * 登录成功
   * @param loginType 登录方式
   * @param data 登录成功后返回的用户信息
   * @param isAutoLogin 是否为自动登录
   * @param showMsg 是否需要弹出提示登录成功
   */
  successLogin(loginType, data, isAutoLogin, showMsg) {
    this.saveLoginInfo(loginType, data) // 保存登录信息
    vuexStore.commit(EXECUTE_USER_LOGIN, data) // 保存到state内存
    this.checkBindTb((isBind, data) => {}, 0) // 刷新绑定淘宝账号的状态
    if (showMsg) {
      Toast.succeed('登录成功', 1500)
    }
    if (isAutoLogin && showMsg) {
      // 重载当前页面
      router.go(0)
    }
  },

  /**
   * 退出登录
   */
  logout: function(callback) {
    Dialog.confirm({
      title: '提示',
      content: '确认退出登陆',
      confirmText: '确定',
      onConfirm: () => {
        Api.user.executeUserLogout().then(() => {
          this.removeLoginInfo() // 清除登陆信息
          vuexStore.commit(EXECUTE_USER_LOGOUT) // 删除state内存中的数据
          // 清空购物车数据
          vuexStore.commit(LOGOUT_CART_CLEAR)
          Toast.succeed('退出成功', 1500)
          if (callback) {
            callback()
          } else {
            router.push({ name: 'home' })
          }
        })
      },
    })
  },

  /**
   * 保存登陆信息
   * @param loginType wechat:微信授权登录 account:账号密码登录
   * @param info 用户信息
   */
  saveLoginInfo: function(loginType, info) {
    Cookie.set(Consts.COOKIE_USER_LOGIN_TYPE, loginType)
    Cookie.set(Consts.COOKIE_USER_TOKEN, info.token)
    Cookie.set(Consts.COOKIE_USER_MOBILE, info.mobile)
    Cookie.set(Consts.COOKIE_USER_UNIONID, info.secondLevelDomainID)
    const userInfo = JSON.parse(JSON.stringify(info))
    if (userInfo.cart) {
      delete userInfo.cart
    }
    Cookie.set(Consts.COOKIE_USER_INFO, JSON.stringify(userInfo))
  },

  /**
   * 清除登陆信息
   */
  removeLoginInfo: function() {
    Cookie.del(Consts.COOKIE_USER_LOGIN_TYPE)
    Cookie.del(Consts.COOKIE_USER_TOKEN)
    Cookie.del(Consts.COOKIE_USER_INFO)
    Cookie.del(Consts.COOKIE_USER_MD5_PWD)
    Cookie.del(Consts.COOKIE_USER_UNIONID)
    Cookie.del(Consts.COOKIE_AUTH_TB_ACCOUNT_NAME)
    Cookie.del(Consts.COOKIE_AUTH_TB_ACCOUNT_RELATION_ID)
  },

  /**
   * 检查是否绑定淘宝
   */
  checkBindTb: function(callback, needAuthDialog) {
    Cookie.del(Consts.COOKIE_AUTH_TB_ACCOUNT_NAME)
    Cookie.del(Consts.COOKIE_AUTH_TB_ACCOUNT_RELATION_ID)
    vuexStore.commit(SET_AUTH_TB_ACCOUNT_INFO, { tbAccountName: '', tbRelationId: '' })
    Api.tbk.bindTbCheck(needAuthDialog)
      .then(res => {
        if (res.code === 1) {
          vuexStore.commit(SET_AUTH_TB_ACCOUNT_INFO, { tbAccountName: res.data.tbAccountName, tbRelationId: res.data.tbRelationId })
          callback(true, res.data)
        }
        callback(false)
      })
      .catch(() => {
        callback(false)
      })
  },
  /**
   * 获取淘宝授权的URL
   */
  getTaobaoAuthUrl() {
    const appkey = Consts.TB_AUTH_APPKEY
    const params = `target=${encodeURIComponent(router.currentRoute.fullPath)}&lastHistoryLength=${window.history.length}`
    const redirectURL = encodeURIComponent(`${Consts.TB_AUTH_CALLBACK_HOST}/auth/taobao?${params}`)
    const taobaoApiURL = Consts.TB_AUTH_GET_CODE_URL
    const view = Consts.TB_AUTH_PAGE_VIEW_TYPE
    const authUrl = `${taobaoApiURL}?response_type=code&client_id=${appkey}&redirect_uri=${redirectURL}&state=1212&view=${view}`
    console.log('淘宝授权链接', authUrl)
    return authUrl
  },
  /**
   * 显示淘宝授权
   */
  showTaobaoAuth(isCheckBind) {
    Dialog.confirm({
      title: '提示',
      content: '您尚未绑定淘宝账号,请先绑定~',
      confirmText: '去绑定',
      onConfirm: () => {
        const authURL = this.getTaobaoAuthUrl()
        if (isWeiXin()) {
          _AP.redirect(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, authURL)
        } else {
          window.location.href = authURL
        }
      },
      onCancel: () => {
        if (!isCheckBind) {
          router.go(-1)
        }
      },
    })
  },
}
